<div id="service" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">
            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" (click)="goBack()">
                    <mat-icon>{{'arrow_back' | translate}}</mat-icon>                </button>
                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="subtitle secondary-text">
                        <span>{{'ASSIGN_SERVICE_TO_LOCATION.addServiceToLocation' | translate}}</span>
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->
            <!-- [disabled]="serviceForm.invalid" -->

            <!-- <button mat-raised-button class="save-service-button"
                *ngIf="ChangeStatus"
                (click)="saveService()">
                <span>SAVE</span>
            </button> -->
        </div>
        <!-- / HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT -->
            <div class="content p-24">

                <div cdkDropListGroup>
                    <div class="example-container ">
                        <h2>{{'ASSIGN_SERVICE_TO_LOCATION.tenantServicesAvailable' | translate}} </h2>
                        <div cdkDropList [cdkDropListData]="TenantServices" class="example-list"
                            cdkDropListSortingDisabled (cdkDropListDropped)="drop($event)"
                            (cdkDropListEntered)="openDialog(false , $event)">
                            <div [name]="item.id + '/'+item.name" class="example-box"
                                *ngFor="let item of TenantServices" cdkDrag>{{item.name}}</div>
                        </div>
                    </div>

                    <div class="example-container">
                        <h2>{{'ASSIGN_SERVICE_TO_LOCATION.locationServices' | translate}}</h2>
                        <div cdkDropList [cdkDropListData]="LocationServices" class="example-list" (click)="openDialogTemplate($event,  true)"
                            (cdkDropListEntered)="openDialog(true , $event)" (cdkDropListDropped)="drop($event)">
                            <div [name]="item.id + '/'+item.name" class="example-box"
                                *ngFor="let item of LocationServices" cdkDrag>{{item?.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>